export const TYPE = {
	PAIRED: 'paired',
	BUNDLED: 'bundled',
};

export const BAGGAGE_TRANSFER_OPTIONS = {
	SELF_TRANSFER: 'SELF_TRANSFER',
	AIRLINE_TRANSFER: 'AIRLINE_TRANSFER',
};

export const PERSIST_CHECKOUT_APP = 'persist:checkout_app';